const adminAppUrl = process.env.ADMIN_APP_URL;

export function getLinkToAdminFormTemplateEditor({
  formTemplateSlug,
}: {
  formTemplateSlug: string;
}): string {
  return `${adminAppUrl}/form-templates/slug/${formTemplateSlug}`;
}

export function navigateToAdminFormTemplateEditor(
  formTemplateSlug: string,
  { openInNewTab = false }: { openInNewTab?: boolean } = {},
): void {
  const link = getLinkToAdminFormTemplateEditor({ formTemplateSlug });
  openInNewTab
    ? window.open(link, '_blank', 'noopener,noreferrer')
    : (window.location.href = link);
}
